import {
    Component,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.pug',
    styleUrls: ['./welcome.component.less']
})
export class WelcomeComponent {

    @Output() next: EventEmitter<any> = new EventEmitter();
    @Output() cancel: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }

    onNext() {
        this.next.emit();
    }

    onCancel() {
        this.cancel.emit();
    }
}
